export const CURRENCIES = [
  { code: "usd", symbol: "$", label: "USD" },
  { code: "eur", symbol: "€", label: "EUR" },
  { code: "gbp", symbol: "£", label: "GBP" },
  { code: "inr", symbol: "₹", label: "INR" },
  { code: "jpy", symbol: "¥", label: "JPY" },
];

export const STORAGE_KEYS = {
  watchlist: "ib:watchlist",
  currency: "ib:currency",
  sort: "ib:sort",
};

export const INTERVALS = {
  marketsMs: 60_000,
  fallbackPollMs: 15_000,
  searchDebounceMs: 300,
  tickerThrottleMs: 1_000,
  binanceRetryBaseMs: 1_000,
  binanceRetryMaxMs: 5_000,
  binanceMaxFailures: 3,
};

export const CACHE_TTL = {
  markets: 60_000,
  global: 60_000,
  chart: 600_000,
  price: 14_000,
};

export const MARKETS_PER_PAGE = 50;

export const SORT_KEYS = [
  "market_cap_rank",
  "current_price",
  "price_change_percentage_1h_in_currency",
  "price_change_percentage_24h_in_currency",
  "price_change_percentage_7d_in_currency",
  "market_cap",
  "total_volume",
];

export const WS_URL =
  "wss://stream.binance.com:9443/stream?streams=btcusdt@miniTicker/ethusdt@miniTicker";

export const WS_COINS = [
  { id: "bitcoin", symbol: "BTC", stream: "btcusdt" },
  { id: "ethereum", symbol: "ETH", stream: "ethusdt" },
];
